import { useQuery } from '@tanstack/react-query';
import { get } from 'app/shared/utils/fetchr';
import { useSelector } from 'react-redux';
import { selectHasEditAiAdminDashboardPermission } from 'app/modules/session/selectors';
import { AI_ADMIN_QUERY_KEYS } from 'app/modules/aiAdmin/queries/keys';
import { AiStatsResponse } from 'app/modules/aiAdmin/responses';

export const useGetAiStats = () => {
  const hasEditAiAdminDashboardPermissions = useSelector(
    selectHasEditAiAdminDashboardPermission,
  );

  return useQuery({
    enabled: hasEditAiAdminDashboardPermissions,
    queryFn: () => get<AiStatsResponse>(`/ai-admin-dashboard/ai-stats`),
    queryKey: AI_ADMIN_QUERY_KEYS.getAiStats(),
  });
};
